const DependentCard = ({
  dependentList,
  handleViewDependent,
  setDeleteDependent,
  handleDeleteDependentData,
  translationMap
}) => {

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.split(" ").filter((word) => word);
    if (words.length === 1) return words[0][0].toUpperCase();
    return words.slice(0, 2).map((word) => word[0]).join(" ").toUpperCase();
  };

  return (
    <>
      <div className="Dependent_white_info_box">
        <div className="Dependent_white_info_title">
          <div className="info_box">
            <span className="icon_box">
              {/* <img
                   src="images/download_img.png"
                   alt="img"
                   className="img-fluid"
                  /> */}
              {getInitials(dependentList?.PatientName)}
            </span>
            <div className="inner_dependent_box">
              <div className="date_box">
                <div className="card-description">
                  <h6 className="MainTitleOne">
                    {dependentList?.PatientName}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="inner_dependent_box">
            <div className="date_box">
              <p>
                <b>{translationMap?.mrn}:</b>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a>{dependentList?.PatientID}</a>
              </p>
            </div>
          </div>
        </div>
        <div className="inner_dependent_box">
          <div className="inner_btn_box">
            <span>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                className="bluetrans_btn_link"
                onClick={() => {
                  handleViewDependent(dependentList?.PatientID);
                }}>

                {translationMap?.viewDetails}
              </a>
            </span>
            <span>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                className="Orange_btn_link"
                data-toggle="modal"
                onClick={() => {
                  setDeleteDependent(true);
                  window.parent.scrollTo(0, 0);
                  handleDeleteDependentData(dependentList?.PatientID);
                }}>
                
                {translationMap?.delete}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>);

};

export default DependentCard;